import React from "react";
import Text from "../../styles/atoms/Text";
import type { UscLabelType } from "../../../../utils/labels";
import { UscLabel } from "../../../../utils/labels";
import { UscServicesType } from "../../../../utils/constants";
import Label from "../../styles/atoms/Label";
import Icon from "../../styles/Icon";
import IconCourtesyVan from "../../assets/visuals/courtesy-van.svg";
import IconWarranty from "../../assets/visuals/warranty.svg";
import Card from "../../styles/molecules/Card";
import { UscService } from "../../../../utils/helpers";

const servicesConfiguration: Record<
    UscService,
    { label: UscLabelType; icon: () => JSX.Element; type: UscServicesType }
> = {
    [UscService.CarDelivery]: {
        label: "uscBasketServicesCarDeliveryTitle",
        icon: () => <IconCourtesyVan />,
        type: UscServicesType.Optional,
    },
    [UscService.Warranty]: {
        label: "uscServicesWarranty",
        icon: () => <IconWarranty />,
        type: UscServicesType.Included,
    },
};

const PdpServiceCard = ({ service }: { service: UscService }): JSX.Element => {
    const { type, label, icon: IconElement } = servicesConfiguration[service];
    return (
        <Card variant="service">
            <IconElement />
            <div>
                <Text tag="h3" variant="h6" color="midnight">
                    <UscLabel label={label} />
                </Text>
                {type === UscServicesType.Included ? (
                    <Label variant="text-icon">
                        <Text variant="paragraph-small-book" color="midnight">
                            <UscLabel label="uscServicesIncluded" />
                        </Text>
                        <Icon variant="check" />
                    </Label>
                ) : (
                    <Text variant="paragraph-small-book" color="brushed-steel">
                        <UscLabel label="uscServicesOptional" />
                    </Text>
                )}
            </div>
        </Card>
    );
};

export default PdpServiceCard;
